import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { InternalActionName } from '../../../../../constants';
import { AISummaryActionComponent } from './ai-summary-action-component';
const AISummaryAction = props => {
  var _context$actions;
  const context = useFlexibleUiContext();
  const actionData = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[InternalActionName.AISummaryAction];
  return actionData ? /*#__PURE__*/React.createElement(AISummaryActionComponent, _extends({}, actionData, props)) : null;
};
export default AISummaryAction;